import React from 'react';
import FeatherIcon from 'feather-icons-react';
import { Modal } from 'antd';
import PropTypes from 'prop-types';
import { Button } from '../../../components/buttons/buttons';

const Popup = ({ confirmPopup, setConfirmPopup, GetCallback, deleteId, page, fromValue }) => { // DeleteApi , sectionTye

    async function Click() {
        GetCallback(deleteId)
    }
    async function Click2() {
        GetCallback(deleteId)
        setConfirmPopup(false)
    }
    const handleClose = () => {
        setConfirmPopup(false)
    }
    const CommitApiCall = () => {
        GetCallback(fromValue)
        setConfirmPopup(false)
    }
    const CommitCall = () => {
        GetCallback()
        setConfirmPopup(false)
    }
    return (
        <>
            <Modal
                title="Confirm Action"
                open={confirmPopup}
                onCancel={handleClose}
                maskClosable={false}
                // bodyStyle={{ width: 'auto', maxWidth: '100%' }}
                // wrapClassName="auto-width-modal"
                footer={[
                    <div>
                        {page === "WithEmail" ?
                            <>
                                <Button htmlType="submit" size="small" className="gray-button" onClick={() => handleClose()}
                                // onClick={() => DeleteApi(deleteId)}
                                >
                                    <FeatherIcon icon="x" /> No
                                </Button>
                                <Button htmlType="submit" size="small" onClick={() => GetCallback(deleteId)} className='button_colors'
                                // onClick={() => GetCallback(deleteId, "Delete")}
                                >
                                    <FeatherIcon icon="check" /> Yes
                                </Button>
                            </> :
                            page === "RemoveMeeting" ?
                                <>
                                    <Button htmlType="submit" size="small" className="gray-button" onClick={() => handleClose()}
                                    // onClick={() => DeleteApi(deleteId)}
                                    >
                                        <FeatherIcon icon="x" /> No
                                    </Button>
                                    <Button htmlType="submit" size="small" onClick={() => GetCallback(deleteId)} className='button_colors'
                                    // onClick={() => GetCallback(deleteId, "Delete")}
                                    >
                                        <FeatherIcon icon="check" /> Yes
                                    </Button>
                                </> :
                                page === "Share" ?
                                    <>
                                        <Button htmlType="submit" size="small" className="gray-button" onClick={() => handleClose()}
                                        // onClick={() => DeleteApi(deleteId)}
                                        >
                                            <FeatherIcon icon="x" /> No
                                        </Button>
                                        <Button htmlType="submit" size="small" onClick={() => GetCallback(deleteId)} className='button_colors'
                                        // onClick={() => GetCallback(deleteId, "Delete")}
                                        >
                                            <FeatherIcon icon="check" /> Yes
                                        </Button>
                                    </> :
                                    page === "GATCOMMIT" ?
                                        <>
                                            <Button htmlType="submit" size="small" className="gray-button" onClick={handleClose}>
                                                <FeatherIcon icon="x" /> No
                                            </Button>
                                            <Button className="button_colors" size="small" onClick={() => CommitApiCall()}>
                                                <FeatherIcon icon="check" /> Yes
                                            </Button>
                                        </>
                                        :
                                        page === "Forcast" ?
                                            <>
                                                <Button htmlType="submit" size="small" className="gray-button" onClick={handleClose}>
                                                    <FeatherIcon icon="x" /> Cancel
                                                </Button>
                                                <Button className="red-button" size="small" onClick={() => CommitCall()}>
                                                    <FeatherIcon icon="git-commit" className="text_iconspace" />Commit
                                                </Button>
                                            </>
                                            :
                                            (page === "Email-config" || page === "Product-Intech") ?
                                                <>
                                                    <Button htmlType="submit" size="small" className="gray-button" onClick={handleClose}>
                                                        <FeatherIcon icon="x" /> Cancel
                                                    </Button>
                                                    <Button htmlType="submit" size="small" onClick={Click} className='red-button'>
                                                        {/* <FeatherIcon icon={sectionTye === "SendGrid" ? "zap-off" : "trash-2"} /> {sectionTye === "SendGrid" ? "De-activate" : "Delete"} */}
                                                        <FeatherIcon icon="trash-2" /> Delete
                                                    </Button>
                                                </>
                                                :
                                                page === "Notes" ?
                                                    <>
                                                        <Button htmlType="submit" size="small" className="gray-button" onClick={handleClose}>
                                                            <FeatherIcon icon="x" /> Cancel
                                                        </Button>
                                                        <Button htmlType="submit" size="small" onClick={Click2} className='red-button'>
                                                            <FeatherIcon icon="trash-2" /> Delete
                                                        </Button>
                                                    </> :
                                                    page === "Clear" ?
                                                        <>
                                                            <Button htmlType="submit" size="small" className="gray-button" onClick={handleClose}>
                                                                <FeatherIcon icon="x" /> No
                                                            </Button>
                                                            <Button htmlType="submit" size="small" onClick={Click} className='red-button'>
                                                                <FeatherIcon icon="trash-2" /> Yes
                                                            </Button>
                                                        </> : page === "Cancel" ?
                                                            <>
                                                                <Button htmlType="submit" size="small" className="gray-button" onClick={handleClose}>
                                                                    <FeatherIcon icon="x" /> No
                                                                </Button>
                                                                <Button className="button_colors" size="small" onClick={() => Click()}>
                                                                    <FeatherIcon icon="check" className="text_iconspace" />Yes
                                                                </Button>
                                                            </> :
                                                            <>
                                                                <Button htmlType="submit" size="small" className="gray-button" onClick={handleClose}>
                                                                    <FeatherIcon icon="x" /> Cancel
                                                                </Button>
                                                                <Button htmlType="submit" size="small" onClick={Click} className='red-button'>
                                                                    <FeatherIcon icon="trash-2" /> Delete
                                                                </Button>
                                                            </>
                        }
                    </div >
                ]}
            >
                <div style={{ padding: "0px 20px" }} >
                    {page === "WithEmail" ?
                        <div className='d-flex align-items-start justify-content-center' style={{ fontSize: 15 }}>
                            <p>Are you sure you want to cancel the meeting?</p>
                            {/* <p>Do you want sent a cancel notification?</p> */}
                            {/* <p>Accept/Tentative/Declined: Do you want to notify the host?</p> */}
                            {/* Received Meeting: Not Accepted, Accepted, Tentative */}
                        </div>
                        :
                        page === "RemoveMeeting" ?
                            <div className='d-flex align-items-start justify-content-center' style={{ fontSize: 15 }}>
                                <p>Are you sure you want to remove this meeting?
                                </p>
                            </div> :
                            page === "Forcast" ?
                                <div className='d-flex align-items-start justify-content-center' style={{ fontSize: 15 }}>
                                    <p>Are you sure you want to commit?</p>
                                </div>
                                :
                                page === "Share" ?
                                    <div className='d-flex align-items-start justify-content-center' style={{ fontSize: 15 }}>
                                        <p>Are you sure you want to revoke?</p>
                                    </div>
                                    :
                                    page === "GATCOMMIT" ?
                                        <div className='d-flex align-items-start justify-content-center' style={{ fontSize: 15 }}>
                                            <p>Are you sure you want to commit?</p>
                                        </div>
                                        :
                                        page === "Email-config" ?
                                            <div className='d-flex align-items-start justify-content-center' style={{ fontSize: 15 }}>
                                                <p>Are you sure you want to remove this email configuration?
                                                </p>
                                            </div>
                                            :
                                            page === "Product-Intech" ?
                                                <div className='d-flex align-items-start justify-content-center' style={{ fontSize: 15 }}>
                                                    {/* {sectionTye === "SendGrid" ? <p>Are you sure you want to de-activate this integration?</p> :  */}
                                                    <p>Are you sure you want to remove this integration?</p>
                                                    {/* } */}
                                                </div>
                                                :
                                                page === "Notes" ?
                                                    <div className='d-flex align-items-start justify-content-center' style={{ fontSize: 15 }}>
                                                        <p>Are you sure you want to delete?</p>
                                                    </div> :
                                                    page === "Clear" ?
                                                        <div className='d-flex align-items-start justify-content-center' style={{ fontSize: 15 }}>
                                                            <p>Are you sure you want to clear all the chat?</p>
                                                        </div> :
                                                        page === "Delete" ?
                                                            <div className='d-flex align-items-start justify-content-center' style={{ fontSize: 15 }}>
                                                                <p>Are you sure you want to delete this chat message?</p>
                                                            </div>
                                                            : page === "Cancel" ?
                                                                <div className='d-flex align-items-start justify-content-center' style={{ fontSize: 15 }}>
                                                                    <p>This will cancel the scheduled send for the campaign. Do you want to continue?</p>
                                                                </div> :
                                                                <div className='d-flex align-items-start justify-content-center' style={{ fontSize: 15 }}>
                                                                    <p>Are you sure you want to delete?</p>
                                                                </div>
                    }
                </div>
            </Modal >
        </>
    );
};

Popup.propTypes = {
    confirmPopup: PropTypes.bool.isRequired,
    setConfirmPopup: PropTypes.func.isRequired,
    GetCallback: PropTypes.func.isRequired,
    deleteId: PropTypes.number.isRequired,
    page: PropTypes.string.isRequired,
    // DeleteApi: PropTypes.func.isRequired,
    fromValue: PropTypes.object.isRequired,
    // sectionTye: PropTypes.string.isRequired,
};

export default Popup;